import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import Modal from 'LuxKit/Modal/Modal'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'

import AccommodationAmenitiesAndPoliciesContent from './AccommodationAmenitiesAndPoliciesContent'
import AccommodationRoomDetailsListContent from './AccommodationRoomDetailsListContent'
import { mapRoomPackage } from './roomPackageUtils'
import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  roomPackage: App.Property.Room | App.HotelPackage | App.BedbankPackage
  hideCounts?: boolean
  checkIn?: string
  flights?: boolean
  onClose?: () => void
  initialImageIndex?: number
}

function AccommodationAmenitiesAndPoliciesModal(props: Props) {
  const { roomPackage, hideCounts } = props
  const intl = useIntl()
  const packageName = useMemo<string>(() => {
    return mapRoomPackage(
      roomPackage,
      ({ name }) => name,
      ({ roomType: { name } }) => name,
      ({ name }) => name,
    )
  }, [roomPackage])

  const modalTitle = intl.formatMessage({
    id: '-4E7t0_dVvUGKabI9BAQ',
    defaultMessage: 'Room amenities & policies',
  })

  const roomDetailsHeading = intl.formatMessage({
    id: 'w1842pLgHSTZqljcGrli',
    defaultMessage: 'Room Details',
  })

  return <Modal
    title={modalTitle}
    subtitle={packageName}
    size="L"
  >
    <Group direction="vertical" gap={20}>
      {roomPackage.description && <CSSBreakpoint max="mobile"><BodyText variant="medium">{roomPackage.description}</BodyText></CSSBreakpoint>}
      <Group direction="vertical" gap={12}>
        <Heading variant="heading6">{roomDetailsHeading}</Heading>
        <AccommodationRoomDetailsListContent roomPackage={roomPackage} hideCounts={hideCounts} />
      </Group>
      <AccommodationAmenitiesAndPoliciesContent roomPackage={roomPackage} />
    </Group>
  </Modal>
}

export default withOfferPageAndReduxState((offerPageState) => ({
  checkIn: offerPageState.checkInDate,
  flights: offerPageState.flights,
}), AccommodationAmenitiesAndPoliciesModal)
